import { render, staticRenderFns } from "./editor-form.vue?vue&type=template&id=6a59cc46&scoped=true&"
import script from "./editor-form.vue?vue&type=script&lang=js&"
export * from "./editor-form.vue?vue&type=script&lang=js&"
import style0 from "./editor-form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editor-form.vue?vue&type=style&index=1&id=6a59cc46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a59cc46",
  null
  
)

export default component.exports